import { addNewContact, patchPartnerContact } from '@atlassian/mpac-api-client';
import { log } from '@atlassian/mpac-utils';
import { getFlagForError, getFlagForSuccess } from "../../../utils/FlagUtils";
import { ADD_CONTACT_FAILED, ADD_CONTACT_SUCCESS, ADD_CONTACT_SUCCESS_DESCRIPTION, EXISTING_USER, MANAGE_CONTACT_FAILED, MANAGE_CONTACT_SUCCESS, MANAGE_CONTACT_SUCCESS_DESCRIPTION, UNKNOWN_USER } from "./AddManageContactModal.label";
import { CONTACT_MODAL_ACTIONS } from "./AddManageContactModal.types";

const handleAddContact = async props => {
  try {
    await addNewContact(props.mpacBaseUrl, props.partnerId, props.formData);
    props.onSubmit();
    props.showFlag(getFlagForSuccess('addContactSuccess', ADD_CONTACT_SUCCESS, "".concat(props.formData.username, " ").concat(ADD_CONTACT_SUCCESS_DESCRIPTION)));
  } catch (error) {
    let errorMessage;

    if (error.status === 400) {
      errorMessage = UNKNOWN_USER;
    } else if (error.status === 409) {
      errorMessage = EXISTING_USER;
    } else {
      log.error('AddManageContactModal', ADD_CONTACT_FAILED, {
        error
      });
    }

    props.showFlag(getFlagForError('addContactFailure', ADD_CONTACT_FAILED, errorMessage));
  }
};

const showManageContactSuccessFlag = showFlag => {
  showFlag(getFlagForSuccess('manageContactSuccess', MANAGE_CONTACT_SUCCESS, MANAGE_CONTACT_SUCCESS_DESCRIPTION));
};

const handleManageContact = async props => {
  if (!props.contact) {
    return;
  }

  const payload = [{
    op: 'replace',
    path: '/permissions',
    value: props.formData.permissions
  }, {
    op: 'replace',
    path: '/roles',
    value: props.formData.roles
  }];

  try {
    await patchPartnerContact(props.mpacBaseUrl, props.contact._links.self.href, payload);
    props.onSubmit();
    showManageContactSuccessFlag(props.showFlag);
  } catch (error) {
    if (error.status === 304) {
      props.onSubmit();
      return showManageContactSuccessFlag(props.showFlag);
    }

    log.error('AddManageContactModal', MANAGE_CONTACT_FAILED, {
      error
    });
    props.showFlag(getFlagForError('manageContactFailure', MANAGE_CONTACT_FAILED));
  }
};

const handleSubmit = props => props.action === CONTACT_MODAL_ACTIONS.ADD ? handleAddContact(props) : handleManageContact(props);

export { handleSubmit };